import isArray from 'lodash/isArray';
import actionTypes from '../actions/actionTypes';
import { mapInboxData } from '../utils/inbox';

const INITIAL_STATE = {
  isLoading: false,
  data: [],
  error: null,
  count: 0,
};

const mapConversation = (payload, message = {}) => {
  const unreadMessages = payload.notificationCount;
  return {
    ...message,
    lastMessageBody: payload.last_message || message.lastMessageBody,
    lastMessageType: payload.message_type || message.lastMessageType,
    internalEntityId: message.internalEntityId || null,
    dateCreated: payload.last_date_created || message.dateCreated,
    externalAddress: payload.contactId || message.externalAddress,
    externalEntityName: payload.contactName || message.externalEntityName,
    subject: payload.message_subject || message.subject,
    unreadMessagesCount: unreadMessages || unreadMessages === 0 ? unreadMessages : message.unreadMessagesCount,
    conversationId: message.conversationId || `${payload.associateId}-${payload.contactId}`,
    direction: message.direction,
    platformMessageId: message.platformMessageId,
  };
};

const updateConversation = (data, payload) => {
  const conversationId = `${payload.associateId}-${payload.contactId}`;
  const oldMessage = data?.find((message) => message.conversationId === conversationId);
  const restMessages = data.filter((message) => message.conversationId !== conversationId);
  return [mapConversation(payload, oldMessage), ...restMessages];
};

const bunchUpdateConversation = (data, payload) => payload.reduce(updateConversation, [...data]);

export const inbox = (state = INITIAL_STATE, { type, payload }) => {
  switch (type) {
    case actionTypes.GET_CONVERSATIONS_V2_LOADING:
      return { ...state, isLoading: true };
    case actionTypes.GET_CONVERSATIONS_V2_SUCCESS:
      return {
        ...state,
        isLoading: false,
        data: [...state.data, ...mapInboxData(payload.items)],
        count: payload.count,
      };

    case actionTypes.CLEAR_CONVERSATIONS:
      return {
        ...state,
        data: [],
        count: 0,
      };

    case actionTypes.UPDATE_CONVERSATION:
      return {
        ...state,
        data: isArray(payload) ? bunchUpdateConversation(state.data, payload) : updateConversation(state.data, payload),
      };
    case actionTypes.GET_CONVERSATIONS_V2_ERROR:
      return { ...state, isLoading: false, error: payload };
    default:
      return state;
  }
};

export default inbox;
